import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RouteBadge from '#/shared/components/RouteBadge';
import AlertsBadge from '#/transit-tracker/components/AlertsBadge';
import { ScreenReaderText } from '#/shared/components/Accessibility';
import { routeType } from '#/prop-types';
import * as Styled from './styled';

function ServiceAlertsList({
  routes,
  alertCountsByRoute,
  defaultMessage,
  navigateToRouteAlerts,
}) {
  return (
    <Styled.AlertListBody>
      {Object.keys(alertCountsByRoute).length ? (
        routes
          .filter(r => alertCountsByRoute[r.id])
          .map(r => (
            <Styled.RouteRow
              key={r.id}
              onClick={() => navigateToRouteAlerts(r.id)}
            >
              <Styled.RouteDetailsColumn>
                <Styled.RouteBadgeColumn aria-hidden="true">
                  <RouteBadge routeId={r.id} />
                </Styled.RouteBadgeColumn>
                <Styled.RouteNameColumn>{r.vanityName}</Styled.RouteNameColumn>
              </Styled.RouteDetailsColumn>
              {alertCountsByRoute[r.id] && (
                <Styled.AlertCountColumn>
                  <div aria-hidden="true">
                    <AlertsBadge text={alertCountsByRoute[r.id].toString()} />
                  </div>
                  <ScreenReaderText>
                    <FormattedMessage
                      id={
                        alertCountsByRoute[r.id] === 1
                          ? 'alerts.route-alerts-count-acc-single'
                          : 'alerts.route-alerts-count-acc-plural'
                      }
                      values={{ count: alertCountsByRoute[r.id] }}
                    />
                  </ScreenReaderText>
                </Styled.AlertCountColumn>
              )}
            </Styled.RouteRow>
          ))
      ) : (
        <Styled.RouteRow>
          <Styled.RouteNameColumn>
            {defaultMessage || <FormattedMessage id="alerts.noalerts" />}
          </Styled.RouteNameColumn>
        </Styled.RouteRow>
      )}
    </Styled.AlertListBody>
  );
}

ServiceAlertsList.propTypes = {
  /** Collection of objects that describe transit routes */
  routes: PropTypes.arrayOf(routeType).isRequired,
  /** Key/Value collection of all alerts grouped by route */
  alertCountsByRoute: PropTypes.objectOf(PropTypes.number).isRequired,
  /** Displayed when the alerts collection is empty */
  defaultMessage: PropTypes.string,
  /** Navigates to a listing of alerts for the provided route */
  navigateToRouteAlerts: PropTypes.func.isRequired,
};

ServiceAlertsList.defaultProps = {
  defaultMessage: null,
};

export default ServiceAlertsList;
